<template>
  <b-modal
    class="new-feature"
    ref="modal"
    centered
    laze
    :hide-footer="true"
  >
    <template slot="modal-header">
      <div class="modal-title text-center w-100">
        New Feature Alert
      </div>
    </template>

    <div>
      <p>
        <span class="font-weight-bold">Overview:</span>
        Need a thermal printer or scale?
      </p>

      <p>
        <span class="font-weight-bold">Description:</span>
        We are excited to partner up with Rollo.&nbsp;&nbsp;They provide both wired and wireless thermal printer, scale and labels.
      </p>

      <p>
        <span class="font-weight-bold">Location:</span>
        <b-link @click="click">Click here</b-link> to learn more or under My Account <i class="fa fa-arrow-right" aria-hidden="true"></i> Label Settings & Hardware.
      </p>

      <hr>

      <p>
        Contact us at <a href="mailto:support@grandshipper.com">support@grandshipper.com</a> to discuss in detail.
      </p>
    </div>

    <div class="text-right">
      <b-btn
        class="btn-new btn-blue-outline default"
        @click="stop"
      >Close</b-btn>
    </div>
  </b-modal>
</template>

<style lang="scss">
  .new-feature {
    .modal-dialog {
      max-width: 550px !important;
    }
    .modal-header {
      background: #29286c;
      color: white;
      padding: 10px;
      font-size: 1.5rem;
    }
  }
</style>

<script>
export default {
  data() {
    return {

    }
  },

  methods: {
    show() {
      this.$refs.modal.show()
    },

    async hide() {
      await this.$refs.modal.hide()
    },

    async click() {
      this.$router.push({ path: '/my-account/print-settings' })
      await this.stop()
    },

    async stop() {
      const new_feature = process.env.MIX_NEW_FEATURE
      localStorage.setItem('new_feature', new_feature)
      this.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modals/NewFeature.vue